import { render, staticRenderFns } from "./addNewPlayerCard.vue?vue&type=template&id=219c7d4e&scoped=true&"
import script from "./addNewPlayerCard.vue?vue&type=script&lang=js&"
export * from "./addNewPlayerCard.vue?vue&type=script&lang=js&"
import style0 from "./addNewPlayerCard.vue?vue&type=style&index=0&id=219c7d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c7d4e",
  null
  
)

export default component.exports